"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
var react_1 = require("react");
var utils_1 = require("./utils");
function useDebounce(delay) {
    var debouncedTimeout = (0, react_1.useRef)(setTimeout(utils_1.noop));
    (0, react_1.useEffect)(function () { return function () {
        clearTimeout(debouncedTimeout.current);
    }; }, []);
    var debounce = (0, react_1.useCallback)(function (debounceFn) {
        clearTimeout(debouncedTimeout.current);
        debouncedTimeout.current = setTimeout(debounceFn, delay || 500);
    }, [delay]);
    return debounce;
}
exports.useDebounce = useDebounce;
